module.exports = __webpack_public_path__ + "static/feature wall - 2-bc7eca5ea32b56ad8c9cf7899f23de0d.jpg";